import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPernyataanVerifikasi2 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPernyataanVerifikasi2 = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN VERIFIKASI
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>NIK</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>NIP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Jabatan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_position ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat Kantor</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_business_address ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. Telp./Fax.</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.phone ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>Menyatakan</div>
          <ol style={{ paddingLeft: "15px" }}>
            <li>Telah melaksanakan verifikasi dokumen Kelompok Sasaran KPR Sejahtera sebanyak ..................................................... Pemohon</li>
            <li>Bahwa verifikasi dilakukan berupa verifikasi administrasi untuk memastikan ketetapan sasaran dan pemenuhan ketentuan KPR Sejahtera.</li>
            <li>
              Bahwa verifikasi administrasi yang dilakukan meliputi:
              <br />{" "}
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>
                  Pemeriksaan kelengkapan dan kesesuaian dokumen persyaratan pemohon yang meliputi:
                  <br />
                  <ol style={{ paddingLeft: "15px" }}>
                    <li>Surat Pemesanan Rumah dari Pengembang</li>
                    <li>Identitas pemohon KPR KPR Sejahtera/KPR SSB/KPR SSM*);</li>
                  </ol>
                </li>
                <li>Pemeriksaan kesesuaian penghasilan Pemohon dengan ketentuan Kelompok Sasaran sesuai ketentuan peraturan perundang-undangan;</li>
                <li>Pemeriksaan kesesuaian harga Rumah Umum Tapak/Sarusun Umum*) dengan batasan harga jual sesuai ketentuan peraturan perundang-undangan;</li>
                <li>Analisa kemampuan mengangsur Pemohon;</li>
              </ol>
            </li>
            <li>
              Pemberian KPR KPR Sejahtera dimaksud telah melalui prosedur sebagai berikut:
              <br />
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>Pemeriksaan kelengkapan data administrasi.</li>
                <li>Wawancara terhadap pemohon.</li>
              </ol>
            </li>
            <li>Berdasarkan hal-hal tersebut pada angka 1 sampai dengan angka 4, maka pemohon sebagaimana dimaksud telah memenuhi syarat dan ketentuan sebagai Kelompok Sasaran KPR Sejahtera dan layak untuk diberikan dana FLPP/SBUM*).</li>
            <li>Seluruh dokumen persyaratan pemohon sebagaimana dimaksud angka 3 butir a, sesuai dengan aslinya dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>

            <li>Surat Pernyataan Verifikasi sesuai dengan aslinya, dapat dipertanggungjawabkan dan dapat dibuktikan apabila dibutuhkan sewaktu-waktu.</li>
          </ol>
          <p>Demikian surat pernyataan ini saya buat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "350px",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "12px",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <span style={{ fontWeight: "bold" }}>PT. BANK TABUNGAN NEGARA (PERSERO) Tbk.</span> <br /> ..................................................... <br /> <br />
                  <br />
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      bottom: "-20px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "60px 12px 20px 12px",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  Nama Lengkap, Jabatan dan Stempel
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
